import { Pagination } from "antd";
import { useEffect, useState } from "react";
import SortingArrow from "../../../../Common/SortingArrow";
import toast from "react-hot-toast";
import globalRequest from "../../../../utils/global/globalRequest";
import * as Apis from "../../../../utils/helper/enum";
import { useDispatch } from "react-redux";
import { paginationLimit, paginationPages } from "../../../../utils/helper/constants";
import { changeLoader } from "../../../../redux/reducers/loader";
import { Link } from "react-router-dom";
import { formatDateFunction, getTabFromOrderStatus } from "../../../../utils/helper/utils";

const CancelledReports = ({ inputData, setInputData }) => {
  const dispatch = useDispatch();

  const [list, setList] = useState([]);
  const [paginationModel, setPaginationModel] = useState(paginationLimit);
  const [totalRows, setTotalRows] = useState(0);

  const getAllReports = async () => {
    dispatch(changeLoader(true));
    try {
      let params = {
        ...inputData,
        page: paginationModel?.page,
        limit: paginationModel?.limit,
      };
      let response = await globalRequest(
        Apis.MANAGE_REPORT.GET_ALL_CANCELLED_ORDERS,
        "get",
        {},
        { params },
        true
      );

      let apiResponse = response?.data;

      if (response?.status === 200 && apiResponse?.status === "SUCCESS") {
        const apiData = apiResponse?.data?.data || [];
        const paginator = apiResponse?.data?.paginator || {};

        setList(apiData);
        setTotalRows(paginator?.totalItems || 0);
      } else {
        toast.error(apiResponse?.message || "Failed to fetch data");
      }
    } catch (e) {
      toast.error(e?.message || "Error fetching data");
    }
    dispatch(changeLoader(false));
  };

  useEffect(() => {
    getAllReports();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputData, paginationModel]);

  const handleSort = (column, order) => {
    setInputData((prev) => ({
      ...prev,
      orderBy: column,
      orderType: order,
    }));
  };

  return (
    <>
      <div className="relative overflow-x-auto">
        <table className="w-full text-left text-sm text-gray-500">
          <thead className="text-gray-700 capitalize text-xs bg-gray-50">
            <tr>
              <th scope="col" className="px-3 py-3 whitespace-nowrap">
                  ID{" "}
                  <SortingArrow
                    onSort={(order) => handleSort("id", order)}
                  />
                </th>
                <th className="px-3 py-3 whitespace-nowrap">
                Order Number{" "}
                <SortingArrow onSort={(order) => handleSort("orderNumber", order)} />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">
                Transaction ID{" "}
                <SortingArrow onSort={(order) => handleSort("transactionId", order)} />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">Customer Info</th>
              <th className="px-3 py-3 whitespace-nowrap">Email</th>
              <th className="px-3 py-3 whitespace-nowrap">
                Payment Method{" "}
                <SortingArrow onSort={(order) => handleSort("paymentMethod", order)} />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">
                Payment Status{" "}
                <SortingArrow onSort={(order) => handleSort("paymentStatus", order)} />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">
                Total Amount{" "}
                <SortingArrow onSort={(order) => handleSort("totalAmount", order)} />
              </th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Mode</th>
              <th className="px-3 py-3 whitespace-nowrap">Cancelled Reason</th>
              <th className="px-3 py-3 whitespace-nowrap">Delivery Date</th>
              <th className="px-3 py-3 whitespace-nowrap">Order Date</th>
            </tr>
          </thead>

          <tbody>
            {list && list.length > 0 ? (
              list.map((item, index) => (
                <tr key={index} className="bg-white border-b">
                  <td className="px-3 py-4 vertical-top whitespace-nowrap">
                      {item?.orderId || "-"}
                    </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    <Link
                      className="cursor-pointer"
                      to={`/order-management/?order_number=${item?.orderNumber}`}
                      state={{
                        orderNumber: item?.orderNumber,
                        activeTab: getTabFromOrderStatus(item?.orderStatus)
                      }}
                      style={{ color: "#37846B", fontWeight: 500 }}
                    >
                      {item?.orderNumber}
                    </Link>
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.transactionId}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.userName} | {item?.userMobile}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.userEmail || "-"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {item?.paymentMethod === "cod"
                      ? "NA"
                      : item?.paymentMethod === "credit_card"
                      ? "Credit Card"
                      : item?.paymentMethod === "apple_pay"
                      ? "Apple Pay"
                      : item?.paymentMethod}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {item?.paymentStatus === "pending"
                      ? "Pending"
                      : item?.paymentStatus === "FAILED"
                      ? "Failed"
                      : "Success"}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.totalAmount} SAR</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.deliveryMode}</td>
                  <td className="px-3 py-4 whitespace-nowrap">{item?.cancelReason ? item?.cancelReason : "-"}</td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {formatDateFunction(item?.deliveryDate, "dd/mm/yyyy")}
                  </td>
                  <td className="px-3 py-4 whitespace-nowrap">
                    {formatDateFunction(item?.createdAt, "dd/mm/yyyy")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={11} className="text-center py-6">
                  No records found
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {list?.length > 0 && (
        <div className="text-right mt-4">
          <Pagination
            defaultCurrent={1}
            total={totalRows}
            pageSizeOptions={paginationPages}
            showSizeChanger
            current={paginationModel?.page}
            pageSize={paginationModel?.limit}
            onChange={(page) => setPaginationModel((prev) => ({ ...prev, page }))}
            onShowSizeChange={(current, size) =>
              setPaginationModel((prev) => ({ ...prev, limit: size }))
            }
          />
        </div>
      )}
    </>
  );
};

export default CancelledReports;
